import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_URL } from '../config';
import './Auth.css'; // Reuse auth styling

function InviteAccept({ token, user, onJoinServer }) {
  const { code } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState('');
  const [joining, setJoining] = useState(false);

  useEffect(() => {
    if (!token) {
      // Store invite code and redirect to login
      localStorage.setItem('pendingInvite', code);
      navigate('/login');
      return;
    }

    fetchInviteDetails();
  }, [code, token]);

  const fetchInviteDetails = async () => {
    try {
      const response = await fetch(`${API_URL}/api/invites/${code}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        const data = await response.json();
        setError(data.error || 'Invalid invite');
        setLoading(false);
        return;
      }

      const data = await response.json();
      setInvite(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching invite:', error);
      setError('Failed to load invite');
      setLoading(false);
    }
  };

  const handleAcceptInvite = async () => {
    setJoining(true);
    try {
      const response = await fetch(`${API_URL}/api/invites/${code}/accept`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        const data = await response.json();
        setError(data.error || 'Failed to join server');
        setJoining(false);
        return;
      }

      const data = await response.json();
      
      // Call parent callback to update server list
      if (onJoinServer) {
        onJoinServer(data.server);
      }
      
      // Redirect to main app
      navigate('/');
    } catch (error) {
      console.error('Error accepting invite:', error);
      setError('Failed to join server');
      setJoining(false);
    }
  };

  if (loading) {
    return (
      <div className="auth-container">
        <div className="auth-box">
          <div className="auth-header">
            <h1>Loading invite...</h1>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="auth-container">
        <div className="auth-box">
          <div className="auth-header">
            <h1>Invite Error</h1>
            <p style={{ color: '#f04747' }}>{error}</p>
          </div>
          <button 
            className="auth-button" 
            onClick={() => navigate('/')}
            style={{ marginTop: '20px' }}
          >
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-header">
          <h1>You've been invited!</h1>
          <p>You've been invited to join</p>
        </div>
        
        <div style={{ 
          background: '#2f3136', 
          padding: '20px', 
          borderRadius: '8px', 
          margin: '20px 0',
          textAlign: 'center'
        }}>
          <h2 style={{ color: '#fff', marginBottom: '8px', fontSize: '24px' }}>
            {invite.server_name}
          </h2>
          <p style={{ color: '#b9bbbe', fontSize: '14px' }}>
            {invite.member_count} {invite.member_count === 1 ? 'member' : 'members'}
          </p>
        </div>

        <button 
          className="auth-button" 
          onClick={handleAcceptInvite}
          disabled={joining}
        >
          {joining ? 'Joining...' : 'Accept Invite'}
        </button>
        
        <div style={{ textAlign: 'center', marginTop: '16px' }}>
          <button 
            onClick={() => navigate('/')}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#00aff4',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default InviteAccept;
